module.exports = __webpack_public_path__ + "img/2012-12-14 18.19.13.460e7b23.jpg";